import { useEffect, useRef } from 'react';
export function usePrevious(value, defaultValue) {
    var _a;
    const ref = useRef();
    useEffect(() => {
        ref.current = value;
    }, [value]);
    return (_a = ref.current) !== null && _a !== void 0 ? _a : defaultValue;
}
